import { Html5QrcodeScanner } from "html5-qrcode";
import React, { useEffect, useState, useRef } from "react"
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API } from "../../api/Globals";
import CustomSelect from "../../components/select/CustomSelect";
import { Toast } from 'primereact/toast';
import { storage } from "../../helpers/storage";

const emptyArr = { serie: '' };

const ScannerEntrega = (
    {
        alumnoRow = [],
        onResult,
        onHide = () => { }
    }
) => {
    const [scanResult, setScanResult] = useState(null);
    const [options, setOptions] = useState([])
    const [tablet, setTablet] = useState(emptyArr)

    const toast = useRef(null)
    let bandera = false

    useEffect(() => {
        if (bandera !== true && parseInt(process.env.REACT_APP_SISTEMA) !== 1) {
            const url = (`${BASE_API}Tablets/postAlmObtenerlistadoTabletsparaEntrega`);
            // Endpoint para listar las tablets pendientes en almacen
            helpHttp().post(url, {
                body: {
                    idUsuario: storage.get('id'),
                    idEstatus: 3,
                    idTienda: null,
                    idAlmacen: null,
                    parametrosExtra: "S"
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                bandera = true
                const arr = res.ITEMS.map(x => {
                    let item = {
                        label: x.serie,
                        value: x.serie
                    }
                    return item
                })
                setOptions(arr);
            })
        }
    }, [alumnoRow])


    useEffect(() => {
        const scanner = new Html5QrcodeScanner('reader', {
            qrbox: {
                width: 250,
                height: 250,
            },
            fps: 5,

        });
        scanner.render(success, error);

        function success(result) {
            scanner.clear();
            setScanResult(result);
            insertarSerieAlumno(result)
        }

        function error(err) {
            // console.warn(err);
        }
    }, []);

    const insertarSerieAlumno = (serie) => {
        // console.log(alumnoRow.IdAlumno)
        helpHttp().post(`${BASE_API}Pip/spdObtenerFolioPrendaTIT`, {
            body: {
                CodigoPrenda: parseInt(process.env.REACT_APP_SISTEMA) !== 1 ? "09" : serie.toString().slice(0, 2),
                CodigoTalla: parseInt(process.env.REACT_APP_SISTEMA) !== 1 ? "111" : serie.toString().slice(2, 5),
                Serie: parseInt(process.env.REACT_APP_SISTEMA) !== 1 ? serie : serie.toString().slice(5),
                IdAlumno: alumnoRow.IdAlumno,
                IdTienda: storage.get('IdTienda')
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            // console.log(res)
            if (res.ITEMS.SerieEntregado !== null) {
                let obj = {
                    ...alumnoRow,
                    Serie: serie,
                    DetEntrega: res.ITEMS
                }
                onResult(obj)
                setScanResult(obj.Serie);
                onHide();
            } else {
                if (parseInt(process.env.REACT_APP_SISTEMA) !== 1 && res.ITEMS.SerieEntregado !== null) {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.Mensaje, life: 5000 })
                } else {
                    res.ITEMS.Serie = serie
                    onResult(res.ITEMS);
                    setScanResult(serie)
                    onHide();
                }
            }
        })
    }

    return (
        <div>
            <Toast ref={toast} />
            {!scanResult
                && <div className="grid m-3">
                    <div className="col-12" id="reader"></div>
                    {/* <InputText type="text" value={tablet.serie} onChange={(e) => { setTablet({ ...tablet, serie: e.target.value }) }} /> */}
                    {parseInt(process.env.REACT_APP_SISTEMA) !== 1 && <div className="col-12 mt-3">
                        <CustomSelect
                            autoFocus
                            id={""}
                            defaultValue={tablet.serie}
                            placeholder={'Buscar tableta'}
                            noOptionsMessage={'No se encontraron coincidencias'}
                            options={options}
                            value={tablet.serie}
                            onChange={(value) => { setTablet({ ...tablet, serie: value.value }); insertarSerieAlumno(value.value) }}

                        />
                    </div>}
                </div>
            }
        </div>
    );
};

export default ScannerEntrega;